<!--
  - Copyright (c) 2021 LNBIG.com
  - All rights reserved.
  -->

<template>
  <div ref="qrCode"></div>
</template>

<script>
import dbg from "debug"
const debug = dbg('lnbig:lnbig-qr-code')

import QRCodeStyling, {
  DrawType,
  TypeNumber,
  Mode,
  ErrorCorrectionLevel,
  DotType,
  CornerSquareType,
  CornerDotType,
  Extension
} from 'qr-code-styling'

export default {
  name: "LnbigQrCode",
  props: {
    size: {
      type: Number,
      default: 300
    },
    level: {
      type: String,
      default: 'Q'
    },
    value: {
      type: String,
      required: true
    },
    mode: {
      type: String,
      default: 'Alphanumeric'
    }
  },
  data() {
    return {
      qrCode: null
    }
  },
  created() {
    this.qrCode = new QRCodeStyling(this.options)
  },
  mounted : function() {
    this.qrCode.append(this.$refs.qrCode)
  },
  computed: {
    options() {
      return {
        width: this.size,
        height: this.size,
        data: this.value,
        image: '/favicon.svg',
        //image: '/favicon-32x32.png',
        margin: 10,
        qrOptions: {
          typeNumber: 0,
          mode: this.mode,
          errorCorrectionLevel: this.level,
        },
        imageOptions: {
          hideBackgroundDots: false,
          imageSize: 0.5,
          margin: 20,
          crossOrigin: 'use-credentials',
        },
        dotsOptions: {
          color: '#5400A9',
          // gradient: {
          //   type: 'linear', // 'radial'
          //   rotation: 0,
          //   colorStops: [{ offset: 0, color: '#8688B2' }, { offset: 1, color: '#77779C' }]
          // },
          type: 'rounded'
        },
        backgroundOptions: {
          color: '#ffffff',
          // gradient: {
          //   type: 'linear', // 'radial'
          //   rotation: 0,
          //   colorStops: [{ offset: 0, color: '#ededff' }, { offset: 1, color: '#e6e7ff' }]
          // },
        },
        cornersSquareOptions: {
          color: '#35495E',
          type: 'extra-rounded',
          // gradient: {
          //   type: 'linear', // 'radial'
          //   rotation: 180,
          //   colorStops: [{ offset: 0, color: '#25456e' }, { offset: 1, color: '#4267b2' }]
          // },
        },
        cornersDotOptions: {
          color: '#35495E',
          type: 'dot',
          // gradient: {
          //   type: 'linear', // 'radial'
          //   rotation: 180,
          //   colorStops: [{ offset: 0, color: '#00266e' }, { offset: 1, color: '#4060b3' }]
          // },
        }
      }
    }
  },
  watch: {
    'options': {
      handler: function(val) {
        debug('update, p_1')
        this.qrCode.update(val)
      },
      deep: true
    }
  },
}
</script>

<style scoped>

</style>
